import React from 'react';
import { Puzzle, RefreshCw, ArrowUpDown, Database, Layers, GitMerge } from 'lucide-react';
import { coreFeatures } from '../data/mock';

const iconMap = {
  Puzzle: Puzzle,
  RefreshCw: RefreshCw,
  ArrowUpDown: ArrowUpDown,
  Database: Database,
  Layers: Layers,
  GitMerge: GitMerge,
};

export const CoreFeatures = () => {
  return (
    <div className="features-grid">
      {coreFeatures.map((feature) => {
        const IconComponent = iconMap[feature.icon];
        return (
          <div key={feature.id} className="feature-card">
            <div className="feature-icon">
              {IconComponent && <IconComponent size={24} />}
            </div>
            <h3 className="feature-name">{feature.name}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        );
      })}
    </div>
  );
};